var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['base-card', { 'is-highlighted': _vm.isHighlighted, 'no-pad': _vm.noPad, 'no-overflow': _vm.noOverflow }],on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }